import { ExpandLess, ExpandMore } from '@mui/icons-material';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import HomeIcon from '@mui/icons-material/Home';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import KenColors from '../../../Helpers/Themes/kenColors';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  hideSideBar: boolean;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, hideSideBar }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const handleMenuClick = (menuName: string) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName],
    }));
  };

  const sideNavContents = [
    {
      icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => <HelpOutlineIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'FAQs',
      link: routes.faqs,
      name: 'faqs',
    },
    // {
    //   icon: (isActive: boolean) => <FolderCopyIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
    //   label: 'My Documents',
    //   link: routes.documents,
    //   name: 'My Documents',
    // },
    // {
    //   icon: (isActive: boolean) => <ContactSupportOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
    //   label: 'FAQ',
    //   link: routes.documents,
    //   name: 'FAQ',
    // },
  ].filter(Boolean);

  const isActive = (link: string) => pathname?.startsWith(link);
  const isAnyNestedItemActive = (nestedItems: any[]) => {
    return nestedItems.some((nestedItem) => isActive(nestedItem.link));
  };

  return (
    <>
      {sideNavContents.map((items: any, index) => {
        if (items?.nested) {
          const anyNestedItemActive = isAnyNestedItemActive(items.nestedItems);
          const isMenuOpen = openMenus[items.name] || false;

          return (
            <div key={index}>
              <ListItemButton
                onClick={() => handleMenuClick(items.name)}
                sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px', padding: '0' }}
                className={`${classes.listItemButton} ${anyNestedItemActive && classes.nestedlistItemButtonActive} ${
                  isActive(items.link) ? classes.listItemTextActiveColor : classes.listItemTextColor
                }`}
              >
                {(anyNestedItemActive || isActive(items.link)) && (
                  <Box
                    sx={{
                      width: '4px',
                      height: '36px !important',
                      background:
                        'linear-gradient(145deg, var(--Colors-Secondary-300, #DE6415) 1.84%, var(--Colors-Secondary-200, #F0965C) 97.75%), linear-gradient(108deg, #111029 0.67%, #050077 100.79%), #CEFF1C',
                      borderRadius: '2px',
                      mr: 1,
                      flexShrink: 0,
                    }}
                  />
                )}
                <ListItemIcon sx={{ minWidth: '40px' }}>{items.icon(isMenuOpen)}</ListItemIcon>
                {!hideSideBar && (
                  <>
                    <ListItemText
                      className={`${classes.listItemText} ${anyNestedItemActive && classes.listItemTextActiveColor}  ${
                        isActive(items.link) ? classes.listItemTextActiveColor : classes.listItemTextColor
                      }`}
                      sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}
                    >
                      {items.label}
                    </ListItemText>
                    {isMenuOpen ? <ExpandLess sx={{ color: KenColors.kenWhite }} /> : <ExpandMore sx={{ color: KenColors.kenWhite }} />}
                  </>
                )}
              </ListItemButton>
              <Collapse in={isMenuOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {items.nestedItems.map((nestedItem: any, nestedIndex: any) => (
                    <ListItemButton
                      key={nestedIndex}
                      onClick={() => handleListClick(nestedItem.link, nestedIndex)}
                      className={`${classes.listItemButton} ${isActive(nestedItem.link) && classes.listItemButtonActive}  ${
                        isActive(items.link) ? classes.listItemTextActiveColor : classes.listItemTextColor
                      }`}
                    >
                      <Box sx={{ ml: hideSideBar ? 0 : 1.5, display: 'flex', alignItems: 'center' }}>
                        {/* Orange vertical line for active nested items */}
                        {isActive(nestedItem.link) && (
                          <Box
                            sx={{
                              width: '4px',
                              height: '20px',
                              background:
                                'linear-gradient(145deg, var(--Colors-Secondary-300, #DE6415) 1.84%, var(--Colors-Secondary-200, #F0965C) 97.75%), linear-gradient(108deg, #111029 0.67%, #050077 100.79%), #CEFF1C',
                              borderRadius: '2px',
                              mr: 1,
                              flexShrink: 0,
                            }}
                          />
                        )}
                        <ListItemIcon sx={{ minWidth: '40px' }}>{nestedItem.icon(isActive(nestedItem.link))}</ListItemIcon>
                        {!hideSideBar && (
                          <ListItemText
                            primary={nestedItem.label}
                            className={`${classes.listItemText} ${isActive(nestedItem.link) && classes.listItemTextActiveColor}`}
                            sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}
                          />
                        )}
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          );
        } else {
          return (
            <ListItemButton
              key={index}
              onClick={() => handleListClick(items.link, index)}
              sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px', padding: '10px' }}
              className={`${classes.listItemButton} ${isActive(items.link) && classes.listItemButtonActive}  ${isActive(items.link) ? classes.listItemTextActiveColor : classes.listItemTextColor}`}
            >
              {/* Orange vertical line for active main nav items */}
              {isActive(items.link) && (
                <Box
                  sx={{
                    width: '4px',
                    height: '32px',
                    background:
                      'linear-gradient(145deg, var(--Colors-Secondary-300, #DE6415) 1.84%, var(--Colors-Secondary-200, #F0965C) 97.75%), linear-gradient(108deg, #111029 0.67%, #050077 100.79%), #CEFF1C',
                    borderRadius: '2px',
                    mr: 1,
                    flexShrink: 0,
                  }}
                />
              )}
              <ListItemIcon sx={{ minWidth: '40px' }}>{items.icon(isActive(items.link))}</ListItemIcon>
              {!hideSideBar && (
                <ListItemText className={`${classes.listItemText} ${isActive(items.link) && classes.listItemTextActiveColor}`} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
                  {items.label}
                </ListItemText>
              )}
            </ListItemButton>
          );
        }
      })}
    </>
  );
};

export default SideNavTabs;
